import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/state/app.state';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CurrencyFunctionalityService } from '../../shared/utilities/functionality/currency-functionality.service';
import * as AfterApplyDataConfig from '../../pages/after-apply/config/user-data.config';
import * as loggedInDetailActions from '../../store/actions/loggedin-detail.action';
import * as UserDataConfig from '../../pages/user-details/config/user-data.config';
import { RefNo } from '../../model/ngrx/reference-number.model';
import * as RefNoActions from '../../store/actions/reference-number.actions';
import { PersonalDetails } from '../../model/ngrx/personal-details.model';
import * as PersDetailsActions from '../../store/actions/personal-details.actions';
import { ProductChoice } from '../../model/ngrx/Product-Choice.model';
import { QuotePlaybackRiskWarning } from '../../model/ngrx/playback-risk-warnings.model';
import * as QuotePlaybackRiskWarningActions from '../../store/actions/playback-risk-warnings.actions';
import { UtilityServiceForMedicalService } from '../../pages/medical-underwriting/services/utility-service';
import { DependantDetails } from 'src/app/model/ngrx';
import { AlertModal } from 'src/app/model/alert';
import { UtilService, SERVICE_END_POINT, DealPartnerFunctionalityService, ApplicationDataCaptureService } from 'src/app/shared';
import { quoteLevelConstants } from '../../shared/constants/attribute-values.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'app-edit-details',
    templateUrl: './edit-details.component.html',
    styleUrls: ['./edit-details.component.scss'],
    imports: [ModalComponent]
})
export class EditDetailsComponent implements OnInit {

  @Input() title;
  @Input() storeName;
  @Input() onClickGoTo;
  @Input() dataList: any;
  @Input() ftrpDataList: any;
  @Input() corpDataList: any;
  @Input() parent;
  @Input() isEdit = true;
  @Input() childId;
  @Input() productCode;
  @Input() summmaryDataList: any;
  @Input() referenceNumber;
  @Input() isGMP: string;
  @Input() isGAR: string;
  public contentData;
  public cmsData1;
  protected userInputDetail = UserDataConfig.ElementsConfig;
  protected filedsList = [];
  valueFromStore: Observable<any[]>;
  providerFromStore: Observable<any[]>;
  referenceNumberStore: Observable<RefNo[]>;
  personDetail: PersonalDetails;
  personalDetailsStore: Observable<PersonalDetails[]>;
  productsChoiceStore: Observable<any[]>;
  productsChoice: {};
  fieldValues: any;
  fundProvider: any;
  source: any;
  maturityFlag = false;
  yearlyFlag = true;
  updatedSection: any;
  loginDetail: any;
  private CMSData;
  reviewLabel: string;
  quotePlaybackRiskWarningStore: Observable<QuotePlaybackRiskWarning[]>;
  riskQuestionaryForm: QuotePlaybackRiskWarning;
  dependentDetail: DependantDetails;
  dependentDetailStore: Observable<DependantDetails[]>;
  loginDetails: any[];
  loginDetailsStore: Observable<any[]>;
  isLocked: boolean = false;
  public lockedAlertModalConfig: AlertModal;
  public afterApplyInputDetail = AfterApplyDataConfig.ElementsConfig;
  private responseApplicationData: any[];
  titleFlag = false;
  medicalConditionInfo: boolean = false;
  showContentLabel: boolean = false;
  dependantMedicalConditionInfo: boolean = false;
  quotecalculationData;
  medicalConditionStaticMsg;
  medicalConditionCMSMsg;
  registrationStatus: boolean = false;
  private countriesList;
  isMaturityQuote: boolean = false;
  @Input() viewApplication: boolean = false;
  constructor(private activatedRoute: ActivatedRoute, private store: Store<AppState>,
    private router: Router, private currencyFunctionalityService: CurrencyFunctionalityService,
    private location: Location, private utilService: UtilService,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService, private applicationDatacaptureService: ApplicationDataCaptureService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData;
    this.cmsData1 = this.activatedRoute.snapshot.data.contentData.pleaseConfirmDetails;
    this.providerFromStore = store.select(STORE_VAL.product_choice);
    this.providerFromStore.subscribe(res => {
      if (res && res.length > 0) {
        this.fundProvider = res[0];
      }
    });
    this.personalDetailsStore = store.select(STORE_VAL.personal_details);
    this.personalDetailsStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.personDetail = val[0];
      }
    });
    this.quotePlaybackRiskWarningStore = store.select(STORE_VAL.quote_playback_risk_warning);
    this.quotePlaybackRiskWarningStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.riskQuestionaryForm = val[0];
      }
    });
    this.productsChoiceStore = store.select(STORE_VAL.quote_capture);
    this.productsChoiceStore.subscribe(res => {
      if (res && res.length > 0) {
        this.productsChoice = res[0];

      }
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res && res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    this.dependentDetailStore = this.store.select(STORE_VAL.dependant_details);
    this.dependentDetailStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.dependentDetail = val[0];
      }
    });
    // capturing application store data
    this.store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
        this.isMaturityQuote = val[0].maturityQuote;
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.userFormData();
    this.valueFromStore = this.store.select(this.storeName);
    this.valueFromStore.subscribe(res => {
      if(this.storeName == 'beneficiaryDetails' && res.length === 0) {
        this.fieldValues = res;
      }
      if (res && res.length > 0) {
        this.fieldValues = res[0];
        if(this.storeName == "loggedinDetail") {
          this.fieldValues = res[0].customer;
        }
      }
    });
    this.store.select(STORE_VAL.quote_calculation).subscribe((val) => {
      if (val && val.length > 0) {
        this.quotecalculationData = val[0];
      }
    });
    if (this.isEdit) {
      this.quoteStore();  // Capturing store data of Quote Journey
    } else {
      this.applyStore();  // Capturing store data of Apply Journey
    }
    this.lockedAlertModalConfig = this.contentData['modalConfigLocked'];
    if (this.storeName === 'yourDependantDetails' || this.storeName === 'pensionSavings'
      || this.storeName === 'yourPersonalDetails') {
      this.titleFlag = true;
    } else {
      this.titleFlag = false;
    }
    this.registrationStatus = this.loginDetail.customer.registrationStatus == true ? true : false;
  }
  userFormData = () => {

  }
  formatInput = (title, label, value, fieldValues) => {
    if (title === this.contentData.pleaseConfirmDetails.playBack[0].title) {

      switch (label) {
        case this.contentData.pleaseConfirmDetails.playBack[0].control[5].label:
          value = value.replace(/ /g, '');
          break;
        case this.contentData.pleaseConfirmDetails.playBack[0].control[6].label:
          const gender = this.userInputDetail.genderConfig.options.filter(item => item.code === value);
          value = gender[0].value;
          break;
        case this.contentData.pleaseConfirmDetails.playBack[0].control[7].label:
          const maritalStatus = this.userInputDetail.maritalStatusConfig.options.filter(item => item.code === value);
          value = maritalStatus[0].value;
          break;
        case this.contentData.pleaseConfirmDetails.playBack[0].control[8].label:
          value = value === 'Y' ? this.contentData.generalConstants.yes.charAt(0).toUpperCase() + this.contentData.generalConstants.yes.slice(1) :
            this.contentData.generalConstants.no.charAt(0).toUpperCase() + this.contentData.generalConstants.no.slice(1);
          break;
        case this.contentData.pleaseConfirmDetails.playBack[0].control[9].label:
          const list = this.fieldValues.address;
          value =
            (list.line1 ? list.line1 + ", " : "") +
            (list.line2 ? list.line2 + ", " : "") +
            (list.line3 ? list.line3 + ", " : "") +
            (list.line4 ? list.line4 + ", " : "") +
            (list.postcode ? list.postcode : "");
          break;
      }
    }
    else if (title === this.contentData.pleaseConfirmDetails.playBack[1].title) {
      switch (label) {
        case this.contentData.pleaseConfirmDetails.playBack[1].control[0].label:
          // tslint:disable-next-line:max-line-length
          value = value === 'Y' ? this.contentData.generalConstants.yes.charAt(0).toUpperCase() + this.contentData.generalConstants.yes.slice(1) :
            this.contentData.generalConstants.no.charAt(0).toUpperCase() + this.contentData.generalConstants.no.slice(1);
          break;
        case this.contentData.pleaseConfirmDetails.playBack[1].control[1].label:
          value = value.replace(/ /g, '');
          break;
        case this.contentData.pleaseConfirmDetails.playBack[1].control[2].label:
          const gender = this.userInputDetail.genderConfig.options.filter(item => item.code === value);
          value = gender[0].value;
          break;
        case this.contentData.pleaseConfirmDetails.playBack[1].control[3].label:
          const relationship = this.userInputDetail.relationshipConfig.options.filter(item => item.code === value);
          value = relationship[0].value;
          break;
      }
    }
    else if (title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
      if (this.productCode === 'C') {
        switch (label) {
          case this.contentData.pleaseConfirmDetails.playBack[8].control[0].label:
            value = ((value === 'M') ?
              this.contentData.generalConstants.monthly.charAt(0).toUpperCase() + this.contentData.generalConstants.monthly.slice(1) :
              this.contentData.generalConstants.yearly.charAt(0).toUpperCase() + this.contentData.generalConstants.yearly.slice(1));
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].control[1].label:
            value = ((value === 'A') ?
              this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
              this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1));
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].control[2].label:
            value = (fieldValues['escalationType'] === 'R' ?
              this.contentData.generalConstants.rpi
              : ((fieldValues['escalationType'] === 'N') ?
                this.contentData.generalConstants.no.charAt(0).toUpperCase() + this.contentData.generalConstants.no.slice(1) :
                this.contentData.generalConstants.fixed.charAt(0).toUpperCase() + this.contentData.generalConstants.fixed.slice(1) + ' / ' + value
                + this.contentData.productQuote.percentage));
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].control[3].label:
            value = value + '%';
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].control[4].label:
            value = ((value > 1) ? value = value + '%' : this.cmsData1.notSelected);
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].control[5].label:
            value = ((value > 1) ? value + ' ' + this.contentData.generalConstants.years :
              (value === 1 ? value + ' ' + this.contentData.generalConstants.year : ''));
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].control[6].label:
            value = (value ? this.formatCurrency(value) : 0);
            break;
        }
      } else if (this.productCode === 'H') {
        switch (label) {

          case this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[0].label:
            value = (this.fieldValues['policyTermMonths']) ?
              // tslint:disable-next-line:max-line-length
              value + ' ' + this.contentData.generalConstants.years + ', ' + this.fieldValues['policyTermMonths'] + ' ' +
              (this.fieldValues['policyTermMonths'] > 1 ? this.contentData.generalConstants.months : this.contentData.generalConstants.month) :
              value + ' ' + this.contentData.generalConstants.years;
            break;

          case this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[1].label:
            value = ((this.fieldValues['paymentFrequency'] === 'M') ?
              this.formatCurrency(this.fieldValues['annuitantPension']) + ' ' +
              this.contentData.generalConstants.monthly.charAt(0).toUpperCase() + this.contentData.generalConstants.monthly.slice(1) + ' / ' +
              ((this.fieldValues['paymentAdvance'] === 'A') ?
                this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
              (this.fieldValues['paymentFrequency'] === 'Y') ?
                this.formatCurrency(this.fieldValues['annuitantYearlyPension']) + ' ' +
                this.contentData.generalConstants.yearly.charAt(0).toUpperCase() + this.contentData.generalConstants.yearly.slice(1) + ' / ' +
                ((this.fieldValues['paymentAdvance'] === 'A') ?
                  this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                  this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
                (this.fieldValues['paymentFrequency'] === 'Q') ?
                  this.formatCurrency(this.fieldValues['annuitantYearlyPension'] / 4) + ' ' +
                  this.contentData.generalConstants.quarterly.charAt(0).toUpperCase() + this.contentData.generalConstants.quarterly.slice(1) + ' / ' +
                  ((this.fieldValues['paymentAdvance'] === 'A') ?
                    this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                    this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
                  (this.fieldValues['paymentFrequency'] === 'H') ?
                    this.formatCurrency(this.fieldValues['annuitantYearlyPension'] / 2) + ' ' +
                    // tslint:disable-next-line:max-line-length
                    this.contentData.generalConstants.halfYearly.charAt(0).toUpperCase() + this.contentData.generalConstants.halfYearly.slice(1) + ' / ' +
                    ((this.fieldValues['paymentAdvance'] === 'A') ?
                      this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                      this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
                    '');
            break;

          case this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[2].label:
            value = this.formatCurrency(this.fieldValues['annuitantMaturity']) + ' ' +
              ((this.fieldValues['paymentFrequency'] === 'M') ?
                this.contentData.generalConstants.monthly.charAt(0).toUpperCase() + this.contentData.generalConstants.monthly.slice(1) :
                (this.fieldValues['paymentFrequency'] === 'Y') ?
                  this.contentData.generalConstants.yearly.charAt(0).toUpperCase() + this.contentData.generalConstants.yearly.slice(1) :
                  (this.fieldValues['paymentFrequency'] === 'Q') ?
                    this.contentData.generalConstants.quarterly.charAt(0).toUpperCase() + this.contentData.generalConstants.quarterly.slice(1) :
                    (this.fieldValues['paymentFrequency'] === 'H') ?
                      this.contentData.generalConstants.halfYearly.charAt(0).toUpperCase() + this.contentData.generalConstants.halfYearly.slice(1) : '') + ' / ' +
              ((this.fieldValues['paymentAdvance'] === 'A') ?
                this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1));
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[3].label:
            value = (this.fieldValues['guaranteedTermIndicator'] === 'O' ? ((value > 1) ? value + ' ' + this.contentData.generalConstants.years :
              (value === 1 ? value + ' ' + this.contentData.generalConstants.year : '')) :
              (this.fieldValues['guaranteedTermIndicator'] === 'N' ? 'None' : 'Whole term'));
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[4].label:
            value = (fieldValues['escalationType'] === 'R' ?
              this.contentData.generalConstants.rpi
              : ((fieldValues['escalationType'] === 'N') ?
                this.contentData.generalConstants.no.charAt(0).toUpperCase() + this.contentData.generalConstants.no.slice(1) :
                this.contentData.generalConstants.fixed.charAt(0).toUpperCase() + this.contentData.generalConstants.fixed.slice(1) + ' / ' + value
                + this.contentData.productQuote.percentage));
            break;

          case this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[5].label:
            value = (value ? this.formatCurrency(value) : 0);
            break;
        }
      } else if (this.productCode === 'G') {
        switch (label) {
          case this.contentData.pleaseConfirmDetails.playBack[8].corpControl[0].label:
            // tslint:disable-next-line:max-line-length
            value = (this.fieldValues['policyTermMonths']) ?
              // tslint:disable-next-line:max-line-length
              value + ' ' + this.contentData.generalConstants.years + ', ' + this.fieldValues['policyTermMonths'] + ' ' +
              (this.fieldValues['policyTermMonths'] > 1 ? this.contentData.generalConstants.months : this.contentData.generalConstants.month) :
              value + ' ' + this.contentData.generalConstants.years;
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].corpControl[1].label:
            value = ((value === 'M') ?
              this.formatCurrency(this.fieldValues['annuitantPension']) + ' ' +
              this.contentData.generalConstants.monthly.charAt(0).toUpperCase() + this.contentData.generalConstants.monthly.slice(1) + ' / ' +
              ((this.fieldValues['paymentAdvance'] === 'A') ?
                this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
              (value === 'Y') ?
                this.formatCurrency(this.fieldValues['annuitantYearlyPension']) + ' ' +
                this.contentData.generalConstants.yearly.charAt(0).toUpperCase() + this.contentData.generalConstants.yearly.slice(1) + ' / ' +
                ((this.fieldValues['paymentAdvance'] === 'A') ?
                  this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                  this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
                (value === 'Q') ?
                  this.formatCurrency(this.fieldValues['annuitantYearlyPension'] / 4) + ' ' +
                  this.contentData.generalConstants.quarterly.charAt(0).toUpperCase() + this.contentData.generalConstants.quarterly.slice(1) + ' / ' +
                  ((this.fieldValues['paymentAdvance'] === 'A') ?
                    this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                    this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
                  (value === 'H') ?
                    this.formatCurrency(this.fieldValues['annuitantYearlyPension'] / 2) + ' ' +
                    // tslint:disable-next-line:max-line-length
                    this.contentData.generalConstants.halfYearly.charAt(0).toUpperCase() + this.contentData.generalConstants.halfYearly.slice(1) + ' / ' +
                    ((this.fieldValues['paymentAdvance'] === 'A') ?
                      this.contentData.generalConstants.inadvance.charAt(0).toUpperCase() + this.contentData.generalConstants.inadvance.slice(1) :
                      this.contentData.generalConstants.inarrears.charAt(0).toUpperCase() + this.contentData.generalConstants.inarrears.slice(1)) :
                    '');
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].corpControl[2].label:
            value = (fieldValues['escalationType'] === 'R' ?
              this.contentData.generalConstants.rpi
              : ((fieldValues['escalationType'] === 'N') ?
                this.contentData.generalConstants.no.charAt(0).toUpperCase() + this.contentData.generalConstants.no.slice(1) :
                this.contentData.generalConstants.fixed.charAt(0).toUpperCase() + this.contentData.generalConstants.fixed.slice(1) + ' / ' + value
                + this.contentData.productQuote.percentage));
            break;
          case this.contentData.pleaseConfirmDetails.playBack[8].corpControl[3].label:
            value = (value ? this.formatCurrency(value) : 0);
            break;
        }
      }
    } else if (title === this.contentData.pleaseConfirmDetails.playBack[2].title) {
      switch (label) {
        case this.contentData.pleaseConfirmDetails.playBack[2].control[0].label:
          const netPension = (this.quotecalculationData['benefitBasis'] && this.quotecalculationData['benefitBasis'].length > 0)
            ? this.quotecalculationData['benefitBasis'][0]['netPensionFund'] : 0;
          value = (netPension ? this.formatCurrency(netPension) : 0);
          break;
        case this.contentData.pleaseConfirmDetails.playBack[2].control[1].label:
          value = value === 'Other' ? this.cmsData1.notApplicable : value;
          break;
      }
    }
    return value;
  }
  gotoEdit = (url) => {
    this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
      res => {
        if (res) {
          this.isLocked = true;
        } else {
          this.isLocked = false;
          if (!this.isEdit) {
            alert(this.cmsData1.editAlert);
            return;
          }
          this.loginDetail = {...this.loginDetail, customer: {...this.loginDetail.customer, reviewStatus: true}};

          this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
          this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(this.loginDetail));
          if (this.referenceNumber) {
            this.referenceNumber = { ...this.referenceNumber, editMode: true };
            const data = this.referenceNumber;
            this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
            this.store.dispatch(new RefNoActions.AddReferenceNumber(data));
          }
          if (this.parent && this.parent.controls['consent'].valid) {
            this.personDetail = { ...this.personDetail, consentIndicator: this.parent.controls['consent'].value };

            this.personDetail.consentDate = this.getSystemDate();
            this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
            this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.personDetail));
          }

          if (url === '/quote/your-product-options' && !this.loginDetail) {
            this.location.back();
          } else {
            this.router.navigateByUrl(url.toString());
          }
        }
      }
    );
  }
  formatCurrency = (val) => {
    const reg = new RegExp('^-?\\d+(?:\\.\\d{0,' + 2 + '})?');

    let formattedCurrency = val.toString().match(reg)[0];
    formattedCurrency = parseFloat(formattedCurrency).toFixed(2);
    const formattedValue = '£' + CurrencyFunctionalityService.convertNumberToCurrency(formattedCurrency);
    return formattedValue;
  }
  throwEmpty = (val, lbl, ttl, fieldVals, index, id?: string) => {
    // 'Not provided'
    if (!val) {
      if (this.title === this.contentData.pleaseConfirmDetails.playBack[0].title &&
        lbl === this.contentData.pleaseConfirmDetails.playBack[0].control[9].label) {
        // for binding address for logged in user
        if (fieldVals && fieldVals.address) {
          val = fieldVals.address.postcode;
          return this.formatInput(ttl, lbl, val, fieldVals);
        }

      } else if ((this.productCode === 'H' && this.title === this.contentData.pleaseConfirmDetails.playBack[8].title &&
        lbl === this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[1].label)
        || this.productCode === 'H' && this.title === this.contentData.pleaseConfirmDetails.playBack[8].title &&
        lbl === this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[1].label &&
        this.fieldValues['annuitantYearlyPension'] === 0) {
        return this.contentData.generalConstants.none;
      } else if ((this.productCode === 'H' && this.title === this.contentData.pleaseConfirmDetails.playBack[8].title &&
        lbl === this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[3].label)) {
        return this.formatInput(ttl, lbl, val, fieldVals);
      } else if ((this.title === this.contentData.pleaseConfirmDetails.playBack[4].title ||
        this.title === this.contentData.pleaseConfirmDetails.playBack[6].title) &&
        fieldVals.annuitantMedicalConditions) {
        const annuitantLifestyleMC = fieldVals.annuitantMedicalConditions;
        if (this.title === this.contentData.pleaseConfirmDetails.playBack[6].title) {
          return this.setMedicalConditionData(lbl, this.dataList, index);
        } else {
          return this.setLifestyleData(annuitantLifestyleMC, lbl, id);
        }
      } else if ((this.title === this.contentData.pleaseConfirmDetails.playBack[5].title ||
        this.title === this.contentData.pleaseConfirmDetails.playBack[7].title) &&
        fieldVals.dependentMedicalConditions) {
        const dependantLifestyleMC = fieldVals.dependentMedicalConditions;
        if (this.title === this.contentData.pleaseConfirmDetails.playBack[7].title) {
          return this.setMedicalConditionData(lbl, this.dataList, index);
        } else {
          return this.setLifestyleData(dependantLifestyleMC, lbl, id);
        }
      } else if ((val === null || val == 0) && lbl == 'Tax-free cash') {
        return 'None';
      } else {
        return this.cmsData1.notProvided;
      }
    } else {
      return this.cmsData1.notProvided;
    }
  }
  setLifestyleData = (lifestyleMC, lbl, questionId) => {
    const lifestyle = lifestyleMC.filter(field => field.questionSetName === 'Lifestyle');
    if (lifestyle.length > 0 && lifestyle[0].questions) {
      let unit = null;
      let returnVal = null;
      lifestyle[0].questions.forEach(question => {
        if (question.origoElement && (question.origoElement.toUpperCase() === questionId.toUpperCase())
          && question.responseValue && question.origoAttribute && question.origoAttribute.toUpperCase() === 'UNITS') {
          unit = (question.responseValue && question.responseValue.includes('/')) ?
            question.responseValue.split('/') : question.responseValue;
        } else if (question.origoElement && (question.origoElement.toUpperCase() === questionId.toUpperCase())
          && question.responseValue && !question.origoAttribute) {
          if (unit && Array.isArray(unit) && unit.length > 0) {
            returnVal = returnVal ? returnVal + ' ' + (question.responseValue + unit[0]) :
              (question.responseValue + unit[0]);
            unit = unit.slice(1);
          } else {
            if (lbl === 'Smoking history' && question.responseValue
              && question.responseValue.includes('smoke')) {
              returnVal = question.responseValue + (unit ? ' ' + unit : '');
            } else if (lbl !== 'Smoking history') {
              returnVal = question.responseValue + (unit ? ' ' + unit : '');
            }
          }
        } else if (question.origoElement && questionId && (question.origoElement.toUpperCase() === questionId.toUpperCase())
          && question.responseValue && !question.origoAttribute) {
          returnVal = question.responseValue;
        } else {
          if (questionId && question.id && question.id === questionId) {
            returnVal = question.responseValue;
          }
        }
      });
      if (lbl && lbl.toLowerCase().includes('date') && returnVal && returnVal.includes('-')) {
        return this.formatDate(returnVal);
      } else {
        return returnVal;
      }
    } else {
      return this.cmsData1.notProvided;
    }
  }
  getSystemDate = (): string => {
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    let strDate = dd.toString();
    let strMonth = mm.toString();
    const yyyy = today.getFullYear();
    if (dd < 10) {
      strDate = '0' + dd.toString();
    }
    if (mm < 10) {
      strMonth = '0' + mm.toString();
    }
    const formattedDate = strDate + '/' + strMonth + '/' + yyyy;
    return formattedDate;
  }

  getId(id_value: any): string {
    if (id_value == null) {
      return '';
    }

    const str = String(id_value);
    let s = str.replace(/\s+(.)/g, (match, chr) => chr.toUpperCase());
    s = s.charAt(0).toLowerCase() + s.substr(1);
    return s.replace(/[^\w\s]/g, '');
  }

  
  getTitleFlag(section, title, value, fieldValues) {
    let flag = true;
    if (this.isEdit) {
      if (this.productCode === 'C') {
        if (title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
          // tslint:disable-next-line:max-line-length
          if (this.fieldValues.secondLifePensionPercentage === '0' && section.label === this.contentData.pleaseConfirmDetails.playBack[8].control[3].label) {
            flag = false;
          }
          // tslint:disable-next-line:max-line-length
          if ((this.fieldValues.vpIndicator === 'Inc' || this.fieldValues.vpIndicator === 'Ne' || !this.fieldValues.vpIndicator) && section.label === this.contentData.pleaseConfirmDetails.playBack[8].control[4].label) {
            flag = false;
          }
          if (this.fieldValues.guaranteedTerm === 0 && section.label === this.contentData.pleaseConfirmDetails.playBack[8].control[5].label) {
            flag = false;
          }
          // tslint:disable-next-line:max-line-length
          if (this.fieldValues.taxFreeCashAmount === '0' && section.label === this.contentData.pleaseConfirmDetails.playBack[8].control[6].label) {
            flag = false;
          }
          if (this.fieldValues.vpPercentage === null && section.label === this.contentData.pleaseConfirmDetails.playBack[8].control[4].label) {
            flag = false;
          }
        }
        if (title === this.contentData.pleaseConfirmDetails.playBack[4].title ||
          title === this.contentData.pleaseConfirmDetails.playBack[6].title) {
          if (fieldValues && fieldValues.annuitantMedicalConditions
            && fieldValues.annuitantMedicalConditions.length > 0) {
            const annuitantMC = fieldValues.annuitantMedicalConditions;
            if (title === this.contentData.pleaseConfirmDetails.playBack[4].title) {
              const lifestyle = annuitantMC.filter(field => field.questionSetName === 'Lifestyle');
              if (lifestyle.length > 0 && lifestyle[0].questions) {
                if (section && section.responseMatch && section.responseMatch.includes('/')) {
                  const responseMatch = section.responseMatch.split('/');
                  responseMatch.every(response => {
                    // tslint:disable-next-line:no-shadowed-variable
                    const value = lifestyle[0].questions.filter(question => question.responseValue === response);
                    if (value && value.length > 0) {
                      const enbleControls = lifestyle[0].questions
                        .filter(question => (question.responseValue !== response && question.origoElement === 'regular_smoker_ind'));
                      if (enbleControls.length > 0 && enbleControls[0].responseValue === 'No' && section && !section.parentQuestion) {
                        flag = false;
                        return true;
                      } else {
                        flag = true;
                        return false;
                      }
                    } else {
                      flag = false;
                      return true;
                    }
                  });
                } else if (section && section.responseMatch) {
                  // tslint:disable-next-line:no-shadowed-variable
                  const value = lifestyle[0].questions.filter(question => question.responseValue ===
                    section.responseMatch);
                  if (value && value.length > 0) {
                    flag = true;
                  } else {
                    flag = false;
                  }
                } else if (section && section.parentResponse) {
                  // tslint:disable-next-line:no-shadowed-variable
                  const value = lifestyle[0].questions.filter(question => question.responseValue === section.parentResponse);
                  if (value && value.length > 0) {
                    flag = true;
                  } else {
                    flag = false;
                  }
                }
              }
            } else {
              flag = true;
            }

          }
        } else if (title === this.contentData.pleaseConfirmDetails.playBack[5].title ||
          title === this.contentData.pleaseConfirmDetails.playBack[7].title) {
          if (fieldValues && fieldValues.dependentMedicalConditions
            && fieldValues.dependentMedicalConditions.length > 0) {
            const annuitantMC = fieldValues.dependentMedicalConditions;
            if (title === this.contentData.pleaseConfirmDetails.playBack[5].title) {
              const lifestyle = annuitantMC.filter(field => field.questionSetName === 'Lifestyle');
              if (lifestyle.length > 0 && lifestyle[0].questions) {
                if (section && section.responseMatch && section.responseMatch.includes('/')) {
                  const responseMatch = section.responseMatch.split('/');
                  responseMatch.every(response => {
                    // tslint:disable-next-line:no-shadowed-variable
                    const value = lifestyle[0].questions.filter(question => question.responseValue === response);
                    if (value && value.length > 0) {
                      const enbleControls = lifestyle[0].questions
                        .filter(question => (question.responseValue !== response && question.origoElement === 'regular_smoker_ind'));
                      if (enbleControls.length > 0 && enbleControls[0].responseValue === 'No' && section && !section.parentQuestion) {
                        flag = false;
                        return true;
                      } else {
                        flag = true;
                        return false;
                      }
                    } else {
                      flag = false;
                      return true;
                    }
                  });
                } else if (section && section.responseMatch) {
                  // tslint:disable-next-line:no-shadowed-variable
                  const value = lifestyle[0].questions.filter(question => question.responseValue ===
                    section.responseMatch);
                  if (value && value.length > 0) {
                    flag = true;
                  } else {
                    flag = false;
                  }
                } else if (section && section.parentResponse) {
                  // tslint:disable-next-line:no-shadowed-variable
                  const value = lifestyle[0].questions.filter(question => question.responseValue === section.parentResponse);
                  if (value && value.length > 0) {
                    flag = true;
                  } else {
                    flag = false;
                  }
                }
              }
            } else {
              flag = true;
            }
          }
        }
      }
      if (this.productCode === 'H') {
        if (this.maturityFlag) {
          flag = false;
          this.maturityFlag = false;
        } else {
          if (title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
            if (section.label === this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[1].label) {
              if (value === 0 || value || this.fieldValues['annuitantYearlyPension'] === 0) {
                this.maturityFlag = true;
              } else {
                if (value == null) {
                  flag = false;
                }
              }
          } else if (this.fieldValues.taxFreeCashAmount === '0' && section.label === this.contentData.pleaseConfirmDetails.playBack[8].ftrpControl[4].label) {
              flag = false;
            }
          } else if (title === this.contentData.pleaseConfirmDetails.playBack[1].title) {
            if (section.label === this.contentData.pleaseConfirmDetails.playBack[1].control[0].label) {
              flag = false;
            }
          }
        }
      }
      if (this.productCode === 'G') {
        if (title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
          // tslint:disable-next-line:max-line-length
          if (this.fieldValues.taxFreeCashAmount === '0' && section.label === this.contentData.pleaseConfirmDetails.playBack[8].corpControl[2].label) {
            flag = false;
          }
        } else if (title === this.contentData.pleaseConfirmDetails.playBack[1].title) {
          if (section.label === this.contentData.pleaseConfirmDetails.playBack[1].control[0].label) {
            flag = false;
          }
        }

      }
    } else {
      // if fieldvalues are null , hide the fields
      if (value === null || value === 'Not provided' || value === 0 || value === '0' || value === '') {
        flag = false;
      }
      if (section.label == 'Tax-free cash' && (value === null || value === 0)) {
        flag = true;
      }
      if (section.label == 'Email' && (title == "Your doctor's details" || title == "Your dependant's doctor's details") && (value === null || value === '')) {
        flag = true;
      }

      if (this.responseApplicationData && this.responseApplicationData['quoteFundInfo'][0].cedingProvider != 'J' && section.storeControlName === 'productCode') {
        flag = false;
      }
    }

    return flag;
  }

  getTitle(title) {
    if (this.productCode === 'H' && title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
      title = this.cmsData1.ftrpInfo;
    }
    if (this.productCode === 'G' && title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
      title = this.cmsData1.corpInfo;
    }

    return title;
  }

  getVisibility(title) {
    let visibilityFlag = true;
    if (this.productCode === 'G') {
      if (title === this.contentData.pleaseConfirmDetails.playBack[1].title) {
        visibilityFlag = false;
      } else if (title === this.contentData.pleaseConfirmDetails.playBack[4].title) {
        visibilityFlag = false;
      } else if (title === this.contentData.pleaseConfirmDetails.playBack[5].title) {
        visibilityFlag = false;
      } else if (title === this.contentData.pleaseConfirmDetails.playBack[6].title) {
        visibilityFlag = false;
      } else if (title === this.contentData.pleaseConfirmDetails.playBack[7].title) {
        visibilityFlag = false;
      }
    } else if (this.productCode === 'C' && (title === this.contentData.pleaseConfirmDetails.playBack[7].title
      || title === this.contentData.pleaseConfirmDetails.playBack[6].title)
      && this.dataList.length === 0) {
      visibilityFlag = false;
    } else if (this.productCode === 'C' && title === this.contentData.pleaseConfirmDetails.playBack[5].title
      && this.fieldValues && this.fieldValues.dependentMedicalConditions
      && this.fieldValues.dependentMedicalConditions.length === 0) {
      visibilityFlag = false;
    }
    return visibilityFlag;
  }

  getLabel(label) {
    // tslint:disable-next-line:max-line-length
    if (label === this.contentData.pleaseConfirmDetails.playBack[2].control[0].label) {
      label = label.replace('{}', (this.productCode === 'C' ? 'annuity' : 'plan'));
    }
    if (this.applicationDatacaptureService.checkIfLSAAddedPreviously(this.viewApplication) && label === this.contentData.applicationSummary.summaryList[3].control[0].label) {
        label = label.replace('Allowance?', 'Allowances?')
    }
    return label;
  }
  closeLockedModal() {
    this.isLocked = false;
  }
  quoteStore() {
    if (this.storeName === 'quoteCalculation' && this.fieldValues && this.fieldValues.benefitVariants) {
      const benefitVariants = this.fieldValues.benefitVariants.filter(val => val.selected);
      const taxfreeCash = benefitVariants.length > 0 ? (benefitVariants[0].benefitBasisModel[0].taxFreeCashAmount ?
        benefitVariants[0].benefitBasisModel[0].taxFreeCashAmount : 0) : 0;
      const extTaxfreeCash = benefitVariants.length > 0 ? (benefitVariants[0].benefitBasisModel[0].extTaxFreeCashAmount ?
        benefitVariants[0].benefitBasisModel[0].extTaxFreeCashAmount : 0) : 0;
      // tslint:disable-next-line: max-line-length
      this.fieldValues = benefitVariants.length > 0 ? [{
        ...benefitVariants[0].quickQuoteModel, ...benefitVariants[0].benefitBasisModel[0]
        , ...benefitVariants[0].quoteBasisModel, totalTaxFree: (taxfreeCash + extTaxfreeCash)
      }][0] : [];

      if (this.fieldValues.escalationType === 'R' || this.fieldValues.escalationType === 'N') {
        this.fieldValues.escalationRate = 1;
      }
      if (!this.fieldValues.secondLifePensionPercentage) {
        this.fieldValues.secondLifePensionPercentage = '0';
      }
      {
        this.fieldValues.taxFreeCashAmount = (this.fieldValues.taxFreeCashAmount ?
          this.fieldValues.taxFreeCashAmount : 0) + (this.fieldValues.extTaxFreeCashAmount ?
            this.fieldValues.extTaxFreeCashAmount : 0);
      }
    }

    if (this.storeName === 'dependantDetails' && this.fieldValues && this.fieldValues['dependantQuestion'] === 'N') {
      this.fieldValues = {};
    }

    if (this.storeName === 'yourpension') {
      let depandantVal = (this.dependentDetail && this.dependentDetail.dependantQuestion === 'Y') ? 'Yes' : 'No';
      this.fieldValues = { ...this.fieldValues, dependant: depandantVal };

      if (this.productsChoice['source'] === 'I') {
        this.source = this.userInputDetail.sourcesListCvt.filter(item => item.fundProvider === 'Int.');
      } else if (this.productsChoice['source'] === 'B') {
        this.source = this.userInputDetail.sourcesListCvt.filter(item => item.fundProvider === 'Ext');
      } else {
        this.source = this.userInputDetail.sourcesListCvt.filter(item => item.fundProvider === this.productsChoice['source']);
      }
      this.fieldValues.source = this.source.length > 0 ? this.source[0].value : [];
    }

  }
  applyStore() {
    if (this.fieldValues) {
      if (this.storeName === 'yourPersonalDetails') {
        this.fieldValues = { ...this.fieldValues, title: this.fieldValues.title === 'Other' ? this.fieldValues.otherTitle : this.fieldValues.title };
        this.fieldValues.middleName = this.fieldValues.middleName ? this.fieldValues.middleName : '';
        // tslint:disable-next-line:max-line-length
        this.fieldValues.thirdName = this.fieldValues.thirdName ? this.fieldValues.thirdName : '';
      }
      if (this.storeName === 'yourDependantDetails' && (this.productCode === 'C')) {
        this.fieldValues.title = this.fieldValues.title === 'Other' ? this.fieldValues.otherTitle : this.fieldValues.title;
        this.fieldValues.fname = this.fieldValues.forename.charAt(0).toUpperCase() + this.fieldValues.forename.slice(1);
        this.fieldValues.surname = this.fieldValues.surname.charAt(0).toUpperCase() + this.fieldValues.surname.slice(1);
        // tslint:disable-next-line:max-line-length
        this.fieldValues.middleName = this.fieldValues.middleName ? this.fieldValues.middleName.charAt(0).toUpperCase() + this.fieldValues.middleName.slice(1) : '';
        // tslint:disable-next-line:max-line-length
        this.fieldValues.thirdName = this.fieldValues.thirdName ? this.fieldValues.thirdName.charAt(0).toUpperCase() + this.fieldValues.thirdName.slice(1) : '';
      }
      if (this.storeName === 'annuitantDoctorDetails' || this.storeName === 'dependantDoctorDetails') {
        this.fieldValues.organisationName = this.responseApplicationData['annuitantDoctor']['organisationName'];
      }
      if (this.storeName === 'beneficiaryDetails') {
        this.fieldValues.forEach(element => {
          this.fieldValues.fname = element.forename.charAt(0).toUpperCase() + element.forename.slice(1);
          this.fieldValues.surname = element.surname.charAt(0).toUpperCase() + element.surname.slice(1);
         })
      }
      if (this.storeName === 'pensionSavings') {
        this.fieldValues.forEach(element => {
          if (this.isGMP === 'Y' || this.isGAR) {
            let tfcAmount = this.responseApplicationData['quoteFundInfo'] && this.responseApplicationData['quoteFundInfo'][0] &&
              this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] ? this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] : null;
            element = { ...element, tfcAmt: tfcAmount };
          } else {
            element = { ...element, tfcAmt: ((element.taxfreeSelected && element.taxfreeSelected && element.taxfreeSelected != 'N') ? this.getTaxFreeCashDetails(element) : 0)};
          }
          element = { ...element, drawdownInd: ((this.isGMP === 'Y' || this.isGAR) ? null : element.drawdownInd) };
          element = { ...element, fullFundInd: (this.isMaturityQuote ? (element.fullFundInd === 'F' ? 'Yes' : 'No') : element.drawdownInd) };
        });
      }
      /* defect#3242- display bank account name as overseas bank on nonUK selection in payment-details page*/
      if (this.storeName === 'bankDetails') {
        // tslint:disable-next-line: max-line-length
        let bankname = (this.fieldValues.accountType && (this.fieldValues.accountType === 'Y' || this.fieldValues.accountType === true))
          ? this.cmsData1.overseasBankName : this.fieldValues.bankName;
        this.fieldValues = { ...this.fieldValues, bankName: bankname };
      }

      if (this.storeName === 'clearApply') {
        this.showContentLabel = this.applicationDatacaptureService.showContent(this.responseApplicationData['applicationSubmissionDate']);
        this.fieldValues = { ...this.fieldValues, bankrupt: ((this.fieldValues.bankrupt == 'Y' || this.fieldValues.bankrupt == 'Yes') ? 'Y' : 'N') };
        this.fieldValues = { ...this.fieldValues, lifeTimeAllowance: this.fieldValues.lifeTimeAllowance };
        this.fieldValues = { ...this.fieldValues, pensionPolicy: ((this.fieldValues.pensionPolicy == 'Y' || this.fieldValues.pensionPolicy == 'Yes') ? 'Y' : 'N') };
      }

      if (this.storeName === 'yourLumpSumAllowances') {
        let lumpSumAllowance: string = '';
        let lsaProtection: string = '';
        let lsaQuestion: string = this.applicationDatacaptureService.getRiskAndStaticQuestion('lsaQuestion');
        if (this.applicationDatacaptureService.checkIfLSAAddedPreviously(this.viewApplication) && !lsaQuestion) {
            lumpSumAllowance = this.applicationDatacaptureService.getRiskAndStaticQuestion('lumpSumAllowanceQuestion');
            lsaProtection = this.applicationDatacaptureService.getRiskAndStaticQuestion('lsaProtectionQuestion');
            lsaQuestion = (lumpSumAllowance == 'N') ? 'No' : (lumpSumAllowance == 'Y' && lsaProtection == 'Y') ? 'Yes - with protection' : 'Yes - without protection';
            this.fieldValues = { ...this.fieldValues, lsaQuestion: lsaQuestion };
        } else {
            lsaQuestion = this.DisplayLumpSumText(this.fieldValues.lsaQuestion, this.fieldValues.protectionType);
            const lsDbaQuestion = this.DisplayLumpSumText(this.fieldValues.lsDbaQuestion, this.fieldValues.protectionType);
            this.fieldValues = { ...this.fieldValues, lsaQuestion: lsaQuestion, lsDbaQuestion: lsDbaQuestion };
        }
      }
    }
  }



  DisplayText(lifeTimeAllowance, ltaProtection, ltaProtectionType) {
    if ((lifeTimeAllowance == 'Y' || lifeTimeAllowance == 'Yes - No Protection') && ltaProtection == 'N') {
      return 'Yes - No Protection'
    } else if ((lifeTimeAllowance == 'Y' || lifeTimeAllowance == 'Yes - Primary Protection') && ltaProtection == 'Y' && ltaProtectionType == 'P') {
      return 'Yes - Primary Protection'
    } else if ((lifeTimeAllowance == 'Y' || lifeTimeAllowance == 'Yes - Enhanced Protection') && ltaProtection == 'Y' && ltaProtectionType == 'E') {
      return 'Yes - Enhanced Protection'
    } else if ((lifeTimeAllowance == 'Y' || lifeTimeAllowance == 'Yes - Fixed Protection') && ltaProtection == 'Y' && ltaProtectionType == 'F') {
      return 'Yes - Fixed Protection'
    } else {
      return 'No'
    }

  }

    DisplayLumpSumText(lumpSumAllowance, protectionType) {
        if (lumpSumAllowance == 'N') {
            return 'No';
        } else if (lumpSumAllowance === 'Y' && this.checkIfValueIsEmpty(protectionType)) {
            return 'Yes - without Protection';
        } else if (lumpSumAllowance === 'Y' && !this.checkIfValueIsEmpty(protectionType)) {
            const protType = this.afterApplyInputDetail.lsaProtectionTypeConfig.options.filter(res => res.code === protectionType);
            return 'Yes - ' + (protType && protType.length > 0 ? protType[0].value : '');
        }
    }
    checkIfValueIsEmpty(val) {
        if (val === undefined || val === null || val === '') {
            return true;
        }
        return false;
    }
// Format Input Values of Apply Journey
  formatInputApply = (title, label, value, fieldValues) => {
    if (value !== null && value !== 'Not provided') {
      // formatting PersonalDetails Info
      if (title === this.contentData.applicationSummary.summaryList[0].title) {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[0].control[2].label:
            value = value.replace(/ /g, '');
            break;
          case this.contentData.applicationSummary.summaryList[0].control[4].label:
            const maritalStatus = this.afterApplyInputDetail.maritalStatusConfig.options.filter(item => item.code === value);
            value = maritalStatus[0].value;
            break;
          case this.contentData.applicationSummary.summaryList[0].control[3].label:
            const gender = this.afterApplyInputDetail.genderConfig.options.filter(item => item.code === value);
            value = gender[0].value;
            break;
          case this.contentData.applicationSummary.summaryList[0].control[0].label:
            value = this.titleAppend();
            break;
          case this.contentData.applicationSummary.summaryList[0].control[7].label:
            value = this.addressAppend(fieldValues);
            break;
        }
      } else if (title === this.contentData.applicationSummary.summaryList[1].title) {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[1].control[1].label:
            value = this.addressAppend(fieldValues);
            break;
          case this.contentData.applicationSummary.summaryList[1].control[4].label:
            value = this.formatCurrency(fieldValues.fundValue);
            break;
          case this.contentData.applicationSummary.summaryList[1].control[5].label:
            let amt;
            if (this.isGMP === 'Y' || this.isGAR) {
              amt = this.responseApplicationData['quoteFundInfo'] && this.responseApplicationData['quoteFundInfo'][0] &&
                this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] ? this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] : 0;
            } else {
              amt = ((fieldValues.tfcAmt !== '0' && fieldValues.tfcAmt !== null) ? Number(fieldValues.tfcAmt) :
                ((fieldValues.extTfcAmt !== '0' && fieldValues.extTfcAmt !== null) ? Number(fieldValues.extTfcAmt) : 0));
            }
            value = this.formatCurrency(amt);
            break;
          case this.contentData.applicationSummary.summaryList[1].control[6].label:
            value = fieldValues.fullFundInd === 'F' ? 'Yes' : 'No';
            break;
          case this.contentData.applicationSummary.summaryList[1].control[7].label:
            value = fieldValues.drawdownInd === 'Y' ? 'Yes' : 'No';
            break;
        }
      } else if (title === 'Other information') {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[2].control[0].label:
            value = (value == 'Y') ? 'Yes' : 'No';
            break;
          case this.contentData.applicationSummary.summaryList[2].control[1].label:
            value = this.DisplayText(this.fieldValues.lifeTimeAllowance, this.fieldValues.ltaProtection, this.fieldValues.ltaProtectionType);
            break;
          case this.contentData.applicationSummary.summaryList[2].control[2].label:
            value = (value == 'Y') ? 'Yes' : 'No';
            break;

        }
      } else if (title === this.contentData.applicationSummary.summaryList[4].title) {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[4].control[0].label:
            value = this.titleAppend();
            break;
          case this.contentData.applicationSummary.summaryList[4].control[1].label:
            value = value.replace(/ /g, '');
            break;
          case this.contentData.applicationSummary.summaryList[4].control[2].label:
            if (value === 'S' || value === 'R' || value === 'F') {
              const relationShip = this.afterApplyInputDetail.relationshipConfig.options.filter(item => item.code === value);
              value = relationShip[0].value;
            }
            break;
        }
      } else if (title === this.contentData.applicationSummary.summaryList[5].title) {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[5].control[1].label:
            value = this.addressAppend(fieldValues);
            break;
          case this.contentData.applicationSummary.summaryList[5].control[4].label:
            value = (value == 'Y') ? 'Yes' : 'No';
            break;

        }
      } else if (title === this.contentData.applicationSummary.summaryList[6].title) {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[6].control[1].label:
            value = this.addressAppend(fieldValues);
            break;
          case this.contentData.applicationSummary.summaryList[6].control[4].label:
            value = (value == 'Y') ? 'Yes' : 'No';
            break;

        }
      } else if (title === this.contentData.applicationSummary.summaryList[7].title) {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[7].control[2].label:
            value = value.toUpperCase();
            break;
          case this.contentData.applicationSummary.summaryList[7].control[3].label:
            value = value.toUpperCase();
            break;
          case this.contentData.applicationSummary.summaryList[7].control[4].label:
            value = value.toUpperCase();
            break;
        }
      } else if (title === this.contentData.applicationSummary.summaryList[8].title) {
        switch (label) {
          case this.contentData.applicationSummary.summaryList[8].control[0].label:
            value = this.titleBeneficiaryAppend(fieldValues);
            break;
          case this.contentData.applicationSummary.summaryList[8].control[1].label:
            value = value +'%';
            break;
          case this.contentData.applicationSummary.summaryList[8].control[2].label:
            value = value.replace(/ /g, '');
            break;
          case this.contentData.applicationSummary.summaryList[8].control[3].label:
            value = (fieldValues.ukAddressIndicator == '' || fieldValues.ukAddressIndicator == null) ? 'Same as applicant' :  this.addressAppend(value);
            break;
        }
      }
    }
    return value;
  }

  titleBeneficiaryAppend(data) {

    const title = ((data.userTitle === 'Other') ? data.otherTitle : data.userTitle)  +
      ' ' + data.forename + ' ' + data.surname;
    return title;
  }
  titleAppend() {
    const title = (this.storeName === 'beneficiaryDetails' ? this.fieldValues.userTitle : this.fieldValues.title) +
      ' ' + this.fieldValues.forename + ' ' +
      (this.fieldValues.middleName ? (this.fieldValues.middleName + ' ') : '') +
      (this.fieldValues.thirdName ? (this.fieldValues.thirdName + ' ') : '') + this.fieldValues.surname;
    return title;
  }
  // method to append all address lines including postcode to a string
  addressAppend(data: any) {
    // tslint:disable-next-line:prefer-const
    let addressText;
    if (this.storeName === 'yourPersonalDetails') {
      addressText = data.address.line1;
      if (data.address.line2 !== null && data.address.line2 !== '' && data.address.line2 !== 'Not provided') {
        addressText = addressText + ', ' + data.address.line2;
      }
      if (data.address.line3 !== null && data.address.line3 !== '' && data.address.line3 !== 'Not provided') {
        addressText = addressText + ', ' + data.address.line3;
      }
      if (data.address.line4 !== null && data.address.line4 !== '' && data.address.line4 !== 'Not provided') {
        addressText = addressText + ', ' + data.address.line4;
      }
      if (data.address.postcode !== null && data.address.postcode !== '' && data.address.postcode !== 'Not provided') {
        addressText = addressText + ', ' + data.address.postcode;
      }
    } else if (this.storeName === 'annuitantDoctorDetails' ||
      this.storeName === 'dependantDoctorDetails') {
      addressText = data.addressline1;
      if (data.addressline2 !== null && data.addressline2 !== '' && data.addressline2 !== 'Not provided') {
        addressText = addressText + ', ' + data.addressline2;
      }
      if (data.addressline3 !== null && data.addressline3 !== '' && data.addressline3 !== 'Not provided') {
        addressText = addressText + ', ' + data.addressline3;
      }
      if (data.addressline4 !== null && data.addressline4 !== '' && data.addressline4 !== 'Not provided') {
        addressText = addressText + ', ' + data.addressline4;
      }
      if (data.postcode !== null && data.postcode !== '' && data.postcode !== 'Not provided') {
        addressText = addressText + ', ' + data.postcode;
      }
    } else if (this.storeName === 'pensionSavings') {
      addressText = data.address.line1;
      if (data.address.line2 !== null && data.address.line2 !== '' && data.address.line2 !== 'Not provided') {
        addressText = addressText + ', ' + data.address.line2;
      }
      if (data.address.line3 !== null && data.address.line3 !== '' && data.address.line3 !== 'Not provided') {
        addressText = addressText + ', ' + data.address.line3;
      }
      if (data.address.line4 !== null && data.address.line4 !== '' && data.address.line4 !== 'Not provided') {
        addressText = addressText + ', ' + data.address.line4;
      }
      if (data.address.postcode !== null && data.address.postcode !== '' && data.address.postcode !== 'Not provided') {
        addressText = addressText + ', ' + data.address.postcode;
      }
    } else if (this.storeName === 'beneficiaryDetails') {
      addressText = data.addressline1;
      if (data.addressline2 !== null && data.addressline2 !== '' && data.addressline2 !== 'Not provided') {
        addressText = addressText + ', ' + data.addressline2;
      }
      if (data.addressline3 !== null && data.addressline3 !== '' && data.addressline3 !== 'Not provided') {
        addressText = addressText + ', ' + data.addressline3;
      }
      if (data.addressline4 !== null && data.addressline4 !== '' && data.addressline4 !== 'Not provided') {
        addressText = addressText + ', ' + data.addressline4;
      }
      if (data.postcode !== null && data.postcode !== '' && data.postcode !== 'Not provided') {
        addressText = addressText + ', ' + data.postcode;
      }
      if (data.countryCode !== null && data.countryCode !== '' && data.countryCode !== 'Not provided') {
        addressText = addressText + ', ' + this.getCountryCode(data.countryCode);
      }
    }
    return addressText;
  }

  getCountryCode(value) {
    let countryName = ''
    if (this.countriesList && this.countriesList.length > 0) {
      const countryNameValue = this.countriesList.filter(val => val['key'] == value);
      countryName = (countryNameValue && countryNameValue[0] && countryNameValue[0]['description']) ? countryNameValue[0]['description'] : '';
    }
    return countryName ;
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_PleaseConfirmYourDetails;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.reviewLabel = this.CMSData.string_ReviewCTALabel;
        this.medicalConditionCMSMsg = this.CMSData.string_MedicalConditionsNotDisclosedText;
        // moving medical condition CMS contents inside service response
        if (this.title && this.fieldValues && this.title.includes('medical conditions')) {
          this.setMedicalConditionsKey(this.dataList, this.fieldValues);
        }
      }
    }, err => {
      if (this.title && this.fieldValues && this.title.includes('medical conditions')) {
        if (this.dataList && this.dataList.length === 0) {
          this.setMedicalConditionsKey(this.dataList, this.fieldValues);
        }
      }
    });

    this.utilService.getCountryNames().subscribe(data => {
       this.countriesList = data;
    });
  }
  /** End of code block for CMS */
  setMedicalConditionsKey = (dataList, fieldValues) => {
    let medicalConditions = null;
    if (this.title === 'Your medical conditions') {
      medicalConditions = this.fieldValues.annuitantMedicalConditions;
    } else {
      medicalConditions = this.fieldValues.dependentMedicalConditions;
    }
    const medicalConditionsFiltered = medicalConditions.filter(annuitant =>
    (annuitant.questionSetName.toUpperCase() !== 'LIFESTYLE' &&
      annuitant.questionSetName.toUpperCase() !== 'DAILYLIVING'));
    if (medicalConditionsFiltered.length > 0) {
      this.dependantMedicalConditionInfo = false;
      this.medicalConditionInfo = false;
      if (dataList && dataList.length === 0) {
        medicalConditionsFiltered.forEach((mc, index) => {
          if (mc && mc.questions) {
            let subTypes = mc.questions.filter(question =>
            (question.origoElement === 'name' && question.responseValue &&
              !question.responseValue.toLowerCase().includes('other')));
            if (subTypes.length > 0) {
              const condition = { label: 'Condition', value: subTypes[0].responseValue };
              dataList.push(condition);
            } else if (mc.questionSetName) {
              subTypes = mc.questions.filter(question => question.recurrenceInd);
              if (subTypes.length > 0 && subTypes[0].questionModels && subTypes[0].questionModels.length > 0) {
                const questionList = subTypes[0].questionModels.filter(question => question.responseValue);
                if (questionList && questionList.length > 0) {
                  const condition = { label: 'Condition', value: mc.questionSetName, temp: true };
                  dataList.push(condition);
                  subTypes[0].questionModels.forEach((st, j) => {
                    if (st.origoElement && (st.origoElement.toLowerCase() === 'type' || st.origoElement.toLowerCase() === 'other_name')
                      &&
                      !st.responseValue.toLowerCase().includes('other')
                      &&
                      this.isMedicalCondition(st.origoSection.toLowerCase())) {
                      if (dataList.length > 0 && dataList[dataList.length - 1].temp) {
                        dataList.pop();
                      }
                      const subCondition = { label: 'Condition', value: st.responseValue };
                      dataList.push(subCondition);
                    } else if (st.origoElement && st.origoElement.toLowerCase() === 'diagnosed_date'
                      &&
                      this.isMedicalCondition(st.origoSection.toLowerCase())) {
                      const diagonisedDate = { label: 'Date of diagnosis', value: this.formatDate(st.responseValue) };
                      dataList.push(diagonisedDate);
                    }
                  });
                } else {
                  const condition = { label: 'Condition', value: mc.questionSetName };
                  dataList.push(condition);
                }
              } else {
                const condition = { label: 'Condition', value: mc.questionSetName };
                dataList.push(condition);
              }
            }
            subTypes = mc.questions.filter(question => question.origoElement === 'diagnosed_date');
            if (subTypes.length > 0) {
              const diagonisedDate = {
                label: 'Date of diagnosis',
                value: this.formatDate(subTypes[0].responseValue)
              };
              dataList.push(diagonisedDate);
            }
          }
        });
      }
      if (this.title === 'Your medical conditions') {
        this.medicalConditionInfo = true;
      } else {
        this.dependantMedicalConditionInfo = true;
      }
      this.medicalConditionStaticMsg = 'Activities of daily living (ADL)';
    } else {
      const lifeStyleArr = medicalConditions.filter(annuitant =>
        annuitant.questionSetName.toUpperCase() === 'LIFESTYLE');
      if (lifeStyleArr.length > 0) {
        if (dataList && dataList.length === 0) {
          const condition = { label: 'Condition', value: null };
          dataList.push(condition);
          const diagonisedDate = { label: 'Date of diagnosis', value: null };
          dataList.push(diagonisedDate);
        }
        if (this.title === 'Your medical conditions') {
          this.medicalConditionInfo = true;
        } else {
          this.dependantMedicalConditionInfo = true;
        }
        if (this.CMSData) {
          this.medicalConditionStaticMsg = this.medicalConditionCMSMsg;
        }
      }
    }

  }
  setMedicalConditionData = (label, dataList, index): string => {
    let returnData = null;
    const returnDataArr = dataList[index];
    if (returnDataArr) {
      returnData = returnDataArr.value;
      dataList = dataList.filter(list => list.value !== returnData);
    } else {
      returnData = this.cmsData1.notProvided;
    }
    return returnData ? returnData :
      (!returnDataArr.isSubhead ? this.cmsData1.notProvided : '');
  }
  formatDate = (dateInput): string => {
    let dateArr = dateInput.includes('-') ? dateInput.split('-') : dateInput;
    if (dateArr.length > 1) {
      dateArr = dateArr[1] + '/' + dateArr[0];
    }
    return dateArr;
  }
  isMedicalCondition(origoSection): boolean {
    let flag = false;
    if (origoSection && origoSection.includes('/')) {
      const sectionArr = origoSection.split('/');
      if (sectionArr && sectionArr.length === 3) {
        const section = sectionArr[1].replace(sectionArr[2], '');
        if (section === 's') {
          flag = true;
        }
      }
    }
    return flag;
  }

  getTaxFreeCashDetails(data) {
    if (data.taxfreeSelected == 'C') {
      return (Number(data.tfcAmt)) ? Number(data.tfcAmt) : Number(data.extTfcAmt)
    } else if (data.taxfreeSelected == 'P') {
      if (Number(data.extTfcPct)) {
        return (Number(data.fundValue) * Number(data.extTfcPct)) / 100;
      }
      if (Number(data.tfcPct)) {
        return (Number(data.fundValue) * Number(data.tfcPct)) / 100;
      }
    }
  }
}
